var map = {
	"./decidim/avatar-multiuser.png": 35998,
	"./decidim/brands/google.svg": 19153,
	"./decidim/cc-badge.png": 41152,
	"./decidim/decidim-logo.svg": 98748,
	"./decidim/default-avatar.svg": 2660,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 60032,
	"./decidim/icons.svg": 34239,
	"./decidim/pattern.png": 51440,
	"./decidim/placeholder-card-g.svg": 40645,
	"./decidim/placeholder-card-l.svg": 37102,
	"./decidim/placeholder.jpg": 95453,
	"./decidim/remixicon.symbol.svg": 10353,
	"./decidim/vendor/leaflet/layers-2x.png": 63920,
	"./decidim/vendor/leaflet/layers.png": 21775,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 83098,
	"./decidim/vendor/leaflet/marker-icon.png": 16081,
	"./decidim/vendor/leaflet/marker-shadow.png": 8606,
	"./decidim/vendor/social-share-button/douban.svg": 83376,
	"./decidim/vendor/social-share-button/email.svg": 63213,
	"./decidim/vendor/social-share-button/facebook.svg": 51379,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 24637,
	"./decidim/vendor/social-share-button/hacker_news.svg": 87757,
	"./decidim/vendor/social-share-button/linkedin.svg": 2885,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 77174,
	"./decidim/vendor/social-share-button/pinterest.svg": 28115,
	"./decidim/vendor/social-share-button/reddit.svg": 85735,
	"./decidim/vendor/social-share-button/telegram.svg": 46698,
	"./decidim/vendor/social-share-button/tumblr.svg": 68681,
	"./decidim/vendor/social-share-button/twitter.svg": 1564,
	"./decidim/vendor/social-share-button/vkontakte.svg": 26114,
	"./decidim/vendor/social-share-button/wechat.svg": 42381,
	"./decidim/vendor/social-share-button/whatsapp.svg": 90141,
	"./decidim/vendor/social-share-button/x.svg": 3981,
	"./decidim/vendor/social-share-button/xing.svg": 81523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83339;